module.exports = __webpack_public_path__ + "static/media/contact-swipe.f806f53f.png";